import { Img } from "../../layout/Img"
import { FaPlayCircle } from "../../svgIcons"

export const HeroHeader = ({
  heroTitle,
  heroDescription,
  heroLinks,
  heroPicture,
  heroVideoURL,
  heroStyle,
}) => {
  return (
    <header className="relative">
      {/* <div className="bg-primary">
        <div className="container p-8 mx-auto md:w-9/12">
          <div className="flex flex-col gap-6">
            <div
              className="hero-header--title"
              dangerouslySetInnerHTML={{ __html: heroTitle }}
            />
            <div dangerouslySetInnerHTML={{ __html: heroDescription }} />
            {heroLinks && heroLinks.length > 0 && <div>heroLinks</div>}
            {heroPicture && heroPicture.length > 0 && <div>heroPicture</div>}
          </div>
        </div>
      </div> */}

      <div className="bg-primary">
        <div className="container flex flex-col items-center py-24 mx-auto">
          <div
            className="hero-header--title w-full md:w-9/12 lg:w-7/12 2xl:w-2/4 text-center font-semibold md:text-5xl lg:text-6xl text-white leading-tight lg:leading-[1.5] text-4xl px-4"
            dangerouslySetInnerHTML={{ __html: heroTitle }}
          />
          <div className="w-10/12 mx-10 my-10 leading-tight text-center text-white text-lg lg:mt-6ß sm:max-w-xl sm:mx-auto lg:mx-0 lg-w-7/12 md:pb-10">
            <div dangerouslySetInnerHTML={{ __html: heroDescription }} />
          </div>

          {/* {heroLinks.length > 0 && (
            <>
              {heroLinks.map((item, index) => (
                <div key={index} className="">
                  <a
                    href={item.buttonLink}
                    className="inline-block px-10 py-4 font-semibold text-center text-white bg-transparent border-2 rounded hover:bg-btnhover"
                  >
                    Learn More
                  </a>
                </div>
              ))}
            </>
          )} */}
        </div>
      </div>
      <svg
        xmlns="https://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        className="xl:-mt-5"
      >
        <path fill="#0070f0" fillOpacity="1" d="M0,224L1440,32L1440,0L0,0Z" />
      </svg>
      <div className="container relative z-10 flex flex-col justify-center w-11/12 mx-auto -mt-32 md:w-9/12 2xl:mt-[-24rem] md:-mt-80">
        <Img image={heroPicture[0]}/>
        {heroVideoURL && (
          <button className="absolute inset-0 w-16 h-16 m-auto" type="button">
            <FaPlayCircle className="w-16 h-16 text-white" />
          </button>
        )}
      </div>
      {/* <div className="md:w-10/12 container relative z-10  max-w-[1000px] flex flex-col justify-center mx-auto w-11/12">
      <h1 className="mt-12 text-4xl font-semibold md:mt-24 md:text-6xl text-secondary">
          Us, in a nutshell.
        </h1>

        <p className="mt-10 text-xl xl:mt-3 sm:mx-auto lg:mx-0">
          We bring together people from the public and private sectors to break
          down silos, work collaboratively and reimagine service delivery.
          Together, we tackle complex social issues by pairing talented
          technologists with government change-makers.
        </p>
      </div> */}
    </header>
  )
}
